import { TOGGLE_MEDIA_DATABASE } from './type'

export const toggleMediaDatabase = ( payload ) => ({
  type: TOGGLE_MEDIA_DATABASE,
  payload
})